import withRouter from "../../../utils/withRouter";

import Wrapper from "./Wrapper";

export default withRouter(Wrapper);
